// extracted by mini-css-extract-plugin
export default {"microno":"speechRecog_microno__2704T","clean_product":"speechRecog_clean_product__MzJP1"};